<template>
  <div class="rvr-select" :class="{ loading: loading }">
    <select class="styled-select"
            :id="name"
            v-model="selectedValue"
            :name="name"
            :disabled="loading"
            @change="emitOptionValue"
    >
      <option v-for="(option, value) in options"
              :key="value"
              :value="value"
              :disabled="option.disabled">{{ option.text }}</option>
    </select>
  </div>
</template>


<script>
import { ref, watch, onMounted, toRefs } from 'vue';

export default {
  name: "DropDown",
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [String, Number],
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { modelValue, options } = toRefs(props);

    const selectedValue = ref(modelValue.value || Object.keys(options.value)[0]);

    const emitOptionValue = () => {
      emit('update:modelValue', selectedValue.value);
    };

    watch(modelValue, (newValue) => {
      selectedValue.value = newValue;
    });

    onMounted(() => {
      emitOptionValue();
    });

    return {
      selectedValue,
      emitOptionValue
    };
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
.styled-select {
  border: 1px solid #e9ecef; /* Thicker border */
  border-radius: 8px; /* Rounded corners */
  font-size: 1em;
  padding: 10px 15px;
  max-width: 100%;
  background: #f8f9fa;
}

.styled-select:focus {
  outline: auto 2px Highlight; /* Default focus style for most browsers */
  outline: 5px auto -webkit-focus-ring-color; /* Default focus style for Safari */
}

.loading {
  animation: loading 2s infinite;
  pointer-events: none; /* make the form element unclickable while loading */
}

@keyframes loading {
  0%   {opacity: 0.1;} /* opacity starts at 10% */
  50%  {opacity: 0.5;} /* opacity goes to 50% at midpoint */
  100% {opacity: 0.1;} /* opacity returns to 10% at the end */
}



</style>
